<template>
  <iframe
    id="test"
    src="/share/4300000172899549/mkNvNAcKKgMNKMCvJm7GCCmvuM6yk6UKkBnKYKAV/4100000002451738/list"
    onload="setInterval(function(){
var doc = document.getElementById('test').contentWindow.document;
var strong = doc.getElementsByTagName('strong')[0];
if(strong){strong.innerHTML='佳锐科技';};
var list = doc.getElementsByTagName('a');
for(var e in list)
if(list[e].innerHTML=='伙伴云'){list[e].innerHTML='佳锐科技';list[e].href='http://www.aresoft.cn'}
},100)"
    frameborder="0"
    width="100%"
    height="800px"
    scrolling="auto"
  ></iframe>
</template>
<script>
export default {
  name: 'complain'
};
</script>
